import RenderZoneAdmin from './video-zone-admin';
import { convertFromCamelCase } from '../service/string.service';
require('./style.scss');

export default {
    _renderZoneListener: {},
    _renderZoneViewerListener: {},

    addRenderZoneListenerEvents() {
        this._renderZoneListener = {};
        this._renderZoneViewerListener = {
            saveRenderZones: () => {
                this._saveRenderZonesServer();
            },
            renderZoneImageUpload: (payload) => {
                this._fireEvent('render-zone-image-upload', payload);
            },
            renderZoneAdded: () => {
                this.toggleRenderZoneEditMode(false);
            },
            renderZoneRemoved: () => {
                this._saveRenderZonesServer();
            },
        };

        for (const key in this._renderZoneListener) {
            this.on(convertFromCamelCase(key), this._renderZoneListener[key]);
        }
        for (const key in this._renderZoneViewerListener) {
            this.viewer.on(convertFromCamelCase(key), this._renderZoneViewerListener[key]);
        }
    },

    toggleRenderZoneEditMode(enable) {
        if (typeof enable === 'boolean') {
            this.renderZoneEditMode = enable;
        } else {
            this.renderZoneEditMode = !this.renderZoneEditMode;
        }

        this.viewer.toggleRenderZoneEditorMode(this.renderZoneEditMode);

        if (this.renderZoneEditMode) {
            this.addRenderZoneListenerEvents();
            const sceneId = this.viewer.getScene();
            const scene = this.config && this.config.scenes && this.config.scenes.find(s => String(s.id) === String(sceneId));
            this.viewer.setRenderZoneData(scene && scene.render_zones_json);
        } else {
            this._saveRenderZonesServer();
            this._renderZoneDestroy();
        }

        this._fireEvent('toggle-render-zone-mode', this.renderZoneEditMode);
    },

    _renderZoneDestroy() {
        for (const key in this._renderZoneListener) {
            this.off(convertFromCamelCase(key), this._renderZoneListener[key]);
        }
        for (const key in this._renderZoneViewerListener) {
            this.viewer.off(convertFromCamelCase(key), this._renderZoneViewerListener[key]);
        }
        this.viewer.renderZoneDestroy();
    },

    getRenderZoneEditMode() {
        return this.renderZoneEditMode;
    },

    _saveRenderZonesServer() {
        // Renderer is the source of truth: its _zones reflect every add/remove,
        // including zones removed via the overlay × button (which don't go through
        // RenderZoneManager). Using RenderZoneManager here would re-include removed zones.
        const zones = this.renderZone ? this.renderZone.getZones() : this.viewer.getRenderZones();
        const zonesJson = zones.length ? JSON.stringify(zones) : null;
        const sceneId = this.viewer.getScene();
        const scene = this.config && this.config.scenes && this.config.scenes.find(s => String(s.id) === String(sceneId));
        if (scene) scene.render_zones_json = zonesJson;
        if (this.viewer._imageData) this.viewer._imageData.render_zones_json = zonesJson;
        this._fireEvent('render-zones.save', zones);
    },

    // Mix RenderZoneAdmin methods directly onto this viewer instance
    ...RenderZoneAdmin,
};
